export const PO_REQUEST = "PO_REQUEST";
export const GET_PO_SUCCESS = "GET_PO_SUCCESS";
export const GET_PO_ERROR = "GET_PO_ERROR";
export const PO_RESET = "PO_RESET";

export const PO_RECOMMENDATIONS_REQUEST = "PO_RECOMMENDATIONS_REQUEST";
export const PO_RECOMMENDATIONS_SUCCESS = "PO_RECOMMENDATIONS_SUCCESS";
export const PO_RECOMMENDATIONS_ERROR = "PO_RECOMMENDATIONS_ERROR";
